<template>
  <div v-if="user" class="enter-info">
    <div v-if="logo" class="enter-info__logo-wrap">
      <img :src="logo" class="enter-info__logo" alt="Company logo">
    </div>
    <div class="enter-info__details">
      <VideoRoomEnterCandidate />
      <VideoRoomEnterAdmin v-if="user.isAdmin.value" />
    </div>
  </div>
</template>

<script>
import VideoRoomEnterCandidate from '@/components/VideoRoomEnterCandidate.vue';
import VideoRoomEnterAdmin from '@/components/VideoRoomEnterAdmin.vue';
import useRoom from '@/compositions/useRoom';
import { UserType } from '@/enums';
import { computed } from '@vue/composition-api';

export default {
  name: 'VideoRoomEnterInfo',
  components: { VideoRoomEnterAdmin, VideoRoomEnterCandidate },
  setup() {
    const { user, existingRoom } = useRoom();

    return {
      user,
      UserType,
      logo: computed(() => existingRoom.value?.company?.logo),
    };
  },
};
</script>

<style lang="scss" scoped>
.enter-info {
  display: flex;
  gap: 1.5rem;
  align-items: flex-start;
}

.enter-info__logo-wrap {
  flex-shrink: 0;
  width: 4.5rem;
  height: 4.5rem;
  border-radius: 0.75rem;
  border: 1px solid #EEF2F7;
  background: #FAFBFD;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 0.5rem;
}

.enter-info__logo {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.enter-info__details {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

@media (max-width: 480px) {
  .enter-info {
    flex-direction: column;
    gap: 1rem;
  }

  .enter-info__logo-wrap {
    width: 3.5rem;
    height: 3.5rem;
  }
}
</style>
